import { Dictionary, Group, GroupConfigMode, IValueViewModel, ValidationPageConfiguration } from '../../models';
import * as angular from 'angular';
import { IValidationPageConfigurationService } from '..';
import { IWidget } from '../../widgets';

export interface IWidgetDuplicationService {
    addWidgetToPage(
        groupGuid: string,
        widget: IWidget,
        groupsDictionary: Dictionary<Group>,
        validationPageConfigurations: Dictionary<ValidationPageConfiguration>,
        viewModels: Dictionary<IValueViewModel>,
        update: (type: string, referenceGroup: string, widgets: IWidget[]) => angular.IPromise<ValidationPageConfiguration[]>
    ): angular.IPromise<any>;
}

export class WidgetDuplicationService implements IWidgetDuplicationService {

    static serviceId = 'widgetDuplicationService';
    static $inject = ['validationPageConfigurationService'];

    constructor(
        private _validationPageConfigurationService: IValidationPageConfigurationService,
    ) {
    }


    addWidgetToPage(
        groupGuid: string,
        widget: IWidget,
        groupsDictionary: Dictionary<Group>,
        validationPageConfigurations: Dictionary<ValidationPageConfiguration>,
        viewModels: Dictionary<IValueViewModel>,
        update: (type: string, referenceGroup: string, widgets: IWidget[]) => angular.IPromise<ValidationPageConfiguration[]>
    ) {
        const group = groupsDictionary[groupGuid];
        return this._validationPageConfigurationService.get(groupGuid, viewModels, groupsDictionary)
            .then(widgets => {
                widget.row = widgets.length ? Math.max(...widgets.map(w => w.row + w.sizeY)) : 0;
                widgets = widgets.concat([widget]);
                let promise: angular.IPromise<any>;
                if (group.configMode === GroupConfigMode.ByType) {
                    const vp = Object.values(validationPageConfigurations).find(d => d.name === group.type);
                    const referenceGroup = vp?.referenceGroup;
                    if (referenceGroup) {
                        promise = update(group.type, referenceGroup, widgets);
                    }
                } else {
                    promise = this._validationPageConfigurationService.update(groupGuid, widgets);
                }
                return promise;
            });
    }

}